import React, { useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUser } from '../../components/auth/auth.selector';
import { logout } from '../../redux/reducers/authSlice';
import { BodyBuilder } from '../../exports/Images';
import '../../styles-v2/dropdown/v2-profile-dropdown.css';

const ProfileDropdown = ({ isOpen, onClose }) => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const menuItems = [
    // {
    //   id: 'profile',
    //   label: 'Profile',
    //   icon: (
    //     <svg
    //       width="20"
    //       height="20"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth="2"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     >
    //       <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    //       <circle cx="12" cy="7" r="4"></circle>
    //     </svg>
    //   ),
    //   action: () => {
    //     navigate("/profile");
    //     onClose();
    //   },
    // },
    // {
    //   id: 'analytics',
    //   label: 'Analytics',
    //   icon: (
    //     <svg
    //       width="20"
    //       height="20"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth="2"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     >
    //       <line x1="18" y1="20" x2="18" y2="10"></line>
    //       <line x1="12" y1="20" x2="12" y2="4"></line>
    //       <line x1="6" y1="20" x2="6" y2="14"></line>
    //     </svg>
    //   ),
    //   action: () => {
    //     navigate("/analytics");
    //     onClose();
    //   },
    // },
    // {
    //   id: 'settings',
    //   label: 'Settings',
    //   icon: (
    //     <svg
    //       xmlns="http://www.w3.org/2000/svg"
    //       viewBox="0 0 24 24"
    //       fill="currentColor"
    //       width="20"
    //       height="20"
    //     >
    //       <path d="M5.32943 3.27158C6.56252 2.8332 7.9923 3.10749 8.97927 4.09446C10.1002 5.21537 10.3019 6.90741 9.5843 8.23385L20.293 18.9437L18.8788 20.3579L8.16982 9.64875C6.84325 10.3669 5.15069 10.1654 4.02952 9.04421C3.04227 8.05696 2.7681 6.62665 3.20701 5.39332L5.44373 7.63C6.02952 8.21578 6.97927 8.21578 7.56505 7.63C8.15084 7.04421 8.15084 6.09446 7.56505 5.50868L5.32943 3.27158ZM15.6968 5.15512L18.8788 3.38736L20.293 4.80157L18.5252 7.98355L16.7574 8.3371L14.6361 10.4584L13.2219 9.04421L15.3432 6.92289L15.6968 5.15512ZM8.97927 13.2868L10.3935 14.7011L5.09018 20.0044C4.69966 20.3949 4.06649 20.3949 3.67597 20.0044C3.31334 19.6417 3.28744 19.0699 3.59826 18.6774L3.67597 18.5902L8.97927 13.2868Z"></path>
    //     </svg>
    //   ),
    //   action: () => {
    //     navigate("/settings");
    //     onClose();
    //   },
    // },
    // {
    //   id: 'privacy',
    //   label: 'Privacy',
    //   icon: (
    //     <svg
    //       width="20"
    //       height="20"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth="2"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     >
    //       <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    //     </svg>
    //   ),
    //   action: () => {
    //     navigate("/privacy");
    //     onClose();
    //   },
    // },
    // {
    //   id: 'help',
    //   label: 'Help Center',
    //   icon: (
    //     <svg
    //       width="20"
    //       height="20"
    //       viewBox="0 0 24 24"
    //       fill="none"
    //       stroke="currentColor"
    //       strokeWidth="2"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     >
    //       <circle cx="12" cy="12" r="10"></circle>
    //       <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    //       <line x1="12" y1="17" x2="12.01" y2="17"></line>
    //     </svg>
    //   ),
    //   action: () => {
    //     navigate("/help-center");
    //     onClose();
    //   },
    // },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleLogout = () => {
    dispatch(logout());
    localStorage.clear();
    navigate('/login');
    onClose();
  };

  return (
    <div className="v2-profile-dropdown" ref={dropdownRef}>
      {/* User Info Section */}
      <div className="v2-profile-dropdown__header">
        <img
          src={userInfoData?.profile || BodyBuilder}
          alt="Profile"
          className="v2-profile-dropdown__avatar"
        />
        <div className="v2-profile-dropdown__user-info">
          <h4 className="v2-profile-dropdown__name">{userInfoData?.name || 'John Doe'}</h4>
          <p className="v2-profile-dropdown__email">{userInfoData?.email || 'john@wtfgyms.com'}</p>
        </div>
      </div>

      {/* Divider */}
      <div className="v2-profile-dropdown__divider"></div>

      {/* Menu Items */}
      <div className="v2-profile-dropdown__menu">
        {menuItems.map((item) => (
          <button key={item.id} className="v2-profile-dropdown__item" onClick={item.action}>
            <span className="v2-profile-dropdown__icon">{item.icon}</span>
            <span className="v2-profile-dropdown__label">{item.label}</span>
          </button>
        ))}
      </div>

      {/* Divider */}
      <div className="v2-profile-dropdown__divider"></div>

      {/* Logout Button */}
      <button
        className="v2-profile-dropdown__item v2-profile-dropdown__item--logout"
        onClick={handleLogout}
      >
        <span className="v2-profile-dropdown__icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </span>
        <span className="v2-profile-dropdown__label">Logout</span>
      </button>
    </div>
  );
};

export default ProfileDropdown;
